import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label:
      'It`s refill time! All we need is your consent and any comments you`d like to leave for the pharmacy. ',
    //subLabel: 'If you do not have the information asked below, please Agree to the consent below and submit the form instead. ',
    field: 'rxInfo',
    //questionImage: 'https://cdn.buttercms.com/P3P41YvST86ZDWwMWhmi',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        /*  {
          label: 'From your Drug Prescription, please enter Rx number, the one underlined in red in the SAMPLE image above',
          type: 'number',
          name: 'rxNum',
          placeholder: 'All numbers, underlined in Red'
        },
        {
          label:
            'From your own prescription, please enter the Drug DIN number, the one underlined in blue in the SAMPLE image above',
          type: 'text',
          name: 'drugDin',
          placeholder: 'All numbers, underlined in blue',
        }, */
        {
          label:
            'I consent to a refill of my prescription. Please charge my credit card on file, use my existing copay information, and ship my medication when it is due. By clicking Agree below, I confirm that I authorize this refill.',
          type: 'single_select',
          name: 'refillConsent',
          required: true,
          options: [{ key: 'refillConsent', value: 'Agree' }]
        },
        {
          label:
            'Special instructions for the pharmacy (e.g., dispense earlier or later than scheduled)',
          type: 'text',
          name: 'refillNote',
          placeholder: 'Any note you would like to add'
        }
      ]
    }
  }
];

export default questionsModels;
